module.exports = __webpack_public_path__ + "img/folder.8953fe67.svg";